import React from "react";
import { PageLayoutSkeleton } from "@features/skeletons/common/PageLayoutSkeleton/PageLayoutSkeleton";
import { MessagesSkeleton } from "@features/skeletons/Messages/MessagesSkeleton/MessagesSkeleton";

export const MessagesPageSkeleton: React.FC = () => {
  return (
    <PageLayoutSkeleton>
      <MessagesSkeleton />
    </PageLayoutSkeleton>
  );
};
